import { render, staticRenderFns } from "./ConnectionChip.vue?vue&type=template&id=d0346b18"
import script from "./ConnectionChip.vue?vue&type=script&lang=js"
export * from "./ConnectionChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports